import { useMutation, UseMutationResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getQuestionSpecifications } from 'utils/urls';
import { showErrorToast } from 'utils/showToast';

import { PdfDetails } from 'types/questions';
import { ErrorModal } from 'types/modalTypes';

type TError = ErrorModal;

type TResult = {
  IsSuccess: boolean;
  StatusCode: number;
  Data: PdfDetails;
};

type TVariables = {
  file: File;
};

type TSnapshot = unknown;

function useUploadPDFQuestion(
  setProgress?: (progress: number) => void,
): UseMutationResult<PdfDetails, TError, TVariables, TSnapshot> {
  function updateProgress(evt: any) {
    if (evt.lengthComputable) {
      // evt.loaded the bytes the browser received
      // evt.total the total bytes set by the header
      // jQuery UI progress bar to show the progress on screen
      const percentComplete = (evt.loaded / evt.total) * 100;
      setProgress && setProgress(percentComplete);
    }
  }

  return useMutation(async ({ file }: TVariables) => {
    const uploadResult: TResult = await new Promise((res, rej) => {
      const formData: FormData = new FormData();
      formData.append('file', file);
      const xhr = new XMLHttpRequest();
      xhr.open('POST', getQuestionSpecifications('pdf'));
      xhr.setRequestHeader('Authorization', getTokenWithType());
      xhr.onreadystatechange = function () {
        if (xhr.readyState === xhr.DONE) {
          if (xhr.status === 200) {
            res(JSON.parse(xhr.response));
          } else {
            const error = JSON.parse(xhr.response);
            showErrorToast({
              message: 'Please upload a valid PDF.',
            });
            rej(error);
          }
        }
      };
      xhr.onprogress = updateProgress;
      xhr.upload.addEventListener('progress', updateProgress);
      xhr.onerror = e => rej(e);
      xhr.send(formData);
    });
    return uploadResult.Data;
  });
}

export { useUploadPDFQuestion };
